import { Box, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import FormTreeElement from '../Tree'
import { Icon } from 'packages/eid-icons'
import { Button } from 'components'
import { useTranslation } from 'react-i18next'

const DEFAULT_SECONDARY_ROLE_AND_LOCATION = [
    {
        orgRoleId: '',
        orgRoleFriendlyName: '',
        orgZoneId: '',
        orgZoneFriendlyName: '',
    },
]
const MultiRoleAndLocationTree = ({
    item,
    errorMessage,
    handleSelect,
    value,
}) => {
    const [selectedValue, setSelectedvalue] = useState(
        value?.length > 0 ? value : DEFAULT_SECONDARY_ROLE_AND_LOCATION,
    )

    useEffect(() => {
        setSelectedvalue(
            value?.length > 0 ? value : DEFAULT_SECONDARY_ROLE_AND_LOCATION,
        )
    }, [value])

    const handleTreeSelect = (
        id,
        field,
        index,
        fieldFriendlyName,
        fieldFriendlyNameVal,
    ) => {
        try {
            let tempSelectedValue = [...selectedValue]
            tempSelectedValue[index] = {
                ...tempSelectedValue[index],
                [field]: id,
                [fieldFriendlyName]: fieldFriendlyNameVal,
            }
            setSelectedvalue(tempSelectedValue)
            handleSelect(tempSelectedValue, item?.fieldName)
        } catch (e) {
            console.error('Error in handleTreeSelect:', e)
        }
    }

    const handleAddRemoveRoleAndLocation = (isAdded, index) => {
        try {
            let newSelectedValue

            if (isAdded) {
                newSelectedValue = [
                    ...selectedValue,
                    {
                        orgRoleId: '',
                        orgRoleFriendlyName: '',
                        orgZoneId: '',
                        orgZoneFriendlyName: '',
                    },
                ]
            } else {
                newSelectedValue = selectedValue.filter((_, i) => i !== index)
            }

            setSelectedvalue(newSelectedValue)
            handleSelect(newSelectedValue, item?.fieldName)
        } catch (e) {
            console.error('Error in handleAddRemoveRoleAndLocation:', e)
        }
    }

    return (
        <Box style={{ width: '100%' }}>
            {selectedValue?.map((selValue, index) => {
                return (
                   
                        <Box key={`secondaryRoleAndLocationTree-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '20px',
                                width: '100%',
                                marginBottom: '20px',
                            }}
                        >
                            <Box
                                style={{
                                    width: '49%',
                                }}
                            >
                                <FormTreeElement
                                    value={selValue?.orgRoleId}
                                    handleSelect={(id, fieldName, fieldLabel) =>
                                        handleTreeSelect(
                                            id,
                                            'orgRoleId',
                                            index,
                                            'orgRoleFriendlyName',
                                            fieldLabel,
                                        )
                                    }
                                    item={{
                                        ...item,
                                        apiUrl: item?.apiUrlForRole,
                                        isLocationTree: false,
                                        labelKey: item?.fieldNameForRole,
                                        localeKey: item?.localeKeyRole,
                                        fieldName: item?.fieldName,
                                    }}
                                    errorMessage={
                                        errorMessage && !selValue?.orgRoleId
                                            ? errorMessage
                                            : ''
                                    }
                                    personDetails={{
                                        [item?.fieldNameForRole]:
                                            selValue?.orgRoleFriendlyName,
                                    }}
                                />
                            </Box>
                            <Box
                                style={{
                                    width: '49%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                }}
                            >
                                <Box style={{ width: '86%' }}>
                                    <FormTreeElement
                                        value={selValue?.orgZoneId}
                                        handleSelect={(
                                            id,
                                            fieldName,
                                            fieldLabel,
                                        ) =>
                                            handleTreeSelect(
                                                id,
                                                'orgZoneId',
                                                index,
                                                'orgZoneFriendlyName',
                                                fieldLabel,
                                            )
                                        }
                                        item={{
                                            ...item,
                                            apiUrl: item?.apiUrlForLocation,
                                            isLocationTree: true,
                                            labelKey:
                                                item?.fieldNameForLocation,
                                            localeKey: item?.localeKeyLocation,
                                            fieldName: item?.fieldName,
                                        }}
                                        errorMessage={
                                            errorMessage && !selValue?.orgZoneId
                                                ? errorMessage
                                                : ''
                                        }
                                        personDetails={{
                                            [item?.fieldNameForLocation]:
                                                selValue?.orgZoneFriendlyName,
                                        }}
                                    />
                                </Box>

                                <Box
                                    style={{
                                        paddingTop: '28px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        gap: '10px',
                                        justifyContent: 'space-between',
                                        width: '14%',
                                    }}
                                >
                                    <Box>
                                        {selectedValue?.length > 1 && (
                                            <Icon
                                                name="Delete"
                                                color={'red'}
                                                onClick={() => {
                                                    handleAddRemoveRoleAndLocation(
                                                        false,
                                                        index,
                                                    )
                                                }}
                                            />
                                        )}
                                    </Box>
                                    {(index === selectedValue?.length - 1 ||
                                        !selectedValue?.length) && (
                                        <Box
                                            style={{
                                                marginTop: '-5px',
                                            }}
                                        >
                                            <AddButton
                                                handleAddRemoveRoleAndLocation={
                                                    handleAddRemoveRoleAndLocation
                                                }
                                                index={index}
                                            />
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                   
                )
            })}
        </Box>
    )
}

export default MultiRoleAndLocationTree

const AddButton = ({ handleAddRemoveRoleAndLocation, index }) => {
    const theme = useTheme()
    const { t } = useTranslation()
    return (
        <Button
            onClick={() => handleAddRemoveRoleAndLocation(true, index)}
            style={{
                borderRadius: '0.4rem',
                padding: '6px  7px',
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.common.white,
                fontSize: '12px',
               
                '&:hover': {
                    backgroundColor: theme.palette.primary.main,
                },
            }}
        >
            {t('Add')} 
        </Button>
    )
}
